const FAQ = () => {
  return <div>Here is FAQ page</div>;
};

export default FAQ;
